<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.add_permits') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="namePermissionsSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(p, index) in rowData.businesses_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ p }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{
                              $t('common_words.associated_profiles')
                            }}:</strong
                          >
                        </h6>
                        <span v-for="(p, index) in rowData.roles" :key="index">
                          <el-tag type="info">{{ p.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.associated_users') }}:</strong
                          >
                        </h6>
                        <span v-for="(p, index) in rowData.users" :key="index">
                          <el-tag type="info"
                            >{{ p.first_name }} {{ p.last_name }}</el-tag
                          >
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            top="2%"
            width="70%"
            :title="title"
            :visible.sync="modals.create"
          >
            <form>
              <div class="row mb-2">
                <div class="col-12">
                  {{ $t('common_words.permissions_info') }}
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    ref="nombre"
                    type="text"
                    :label="`${$t('common_words.name')} *`"
                    v-model="permissionForm.name"
                    name="common_words.name"
                    v-validate="modelValidations.nombre"
                    :error="getError('common_words.name', true)"
                    :placeholder="`${$t('common_words.create')}...`"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div
                  v-bind:class="
                    permissionForm.permission_type == 'General'
                      ? 'col-12'
                      : 'col-6'
                  "
                >
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.type_of_permit') }} *</label
                    >
                    <br />
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      v-model="permissionForm.permission_type"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in [
                          $t('common_words.general'),
                          $t('common_words.specific'),
                        ]"
                        class="select-primary"
                        :value="option"
                        :label="option"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="col-6"
                  v-if="permissionForm.permission_type == 'Especifico'"
                >
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_modules_associate')
                    }}</label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('permissionForm.modules', modules)
                      "
                      clearable
                      collapse-tags
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm required-modules"
                      size="large"
                      v-model="permissionForm.modules"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="option in modules"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="
                          `${option.id} - ${option.name}`.replace(/^0 - /, '')
                        "
                        :key="option.id + ' - ' + option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-12">
                  {{ $t('common_words.permissions_association') }}
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_companies')
                    }}</label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect(
                          'permissionForm.businesses_ids',
                          businesses
                        )
                      "
                      collapse-tags
                      clearable
                      filterable
                      multiple
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      v-model="permissionForm.businesses_ids"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="option in businesses"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="`${$t('common_words.per_page')}...`"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              max-height="610"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="90"
                prop="props.roles"
                :label="$t('common_words.associated_profiles')"
                align="center"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.roles.length > 0"
                    :hidden="scope.row.roles.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.roles.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.roles[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                min-width="110"
                prop="props.users"
                :label="$t('common_words.associated_users')"
                align="center"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.users.length > 0"
                    :hidden="scope.row.users.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.users.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.users[0].first_name }}
                      {{ scope.row.users[0].last_name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                min-width="90"
                prop="props.modules"
                :label="$t('common_words.associated_modules')"
                align="center"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.modules.length > 0"
                    :hidden="scope.row.modules.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.modules.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.modules[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="50"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate() && props.row.id > 11"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && props.row.id > 11"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import configTable from './permissionTable';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,

    namePermissionsSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  data() {
    return {
      permissionForm: {
        name: null,
        guard_name: null,
        businesses_ids: [],
        permission_type: 'General',
        modules: [],
      },
      modelValidations: {
        nombre: {
          required: true,
        },
      },
      title: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      businesses: [],
      modals: {
        create: false,
        read: false,
        delete: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      businesses: [],
      modules: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinForm, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.modules = this.concatAll(this.modules.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    openModal(name) {
      if (name == 'create') {
        (this.title = i18n.t('common_words.add_permission')),
          this.$validator.reset();
        this.permissionForm = {
          name: null,
          guard_name: null,
          businesses_ids: [],
          modules: [],
          permission_type: 'General',
        };

        this.permissionForm.businesses_ids = this.selectElementsAsignFromModel(
          1,
          this.permissionForm.businesses_ids,
          this.businesses
        );
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (
            this.permissionForm.permission_type == 'Especifico' &&
            this.permissionForm.modules.length == 0
          ) {
            return this.validationInputsRequired('modules');
          } else {
            this.addEditPermission();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');

      this.permissionForm.modules = [];
      row.modules.forEach((element) => {
        this.permissionForm.modules.push(element.id);
      });

      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('common_words.edit_permission');
      this.permissionForm = Object.assign({}, row);
      this.permissionForm.route = 'permissions';
      this.permissionForm.businesses_ids = Object.values(row.businesses_ids);

      this.permissionForm.modules = [];
      row.modules.forEach((element) => {
        this.permissionForm.modules.push(element.id);
      });

      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.permissionForm = row;
      SweetAlert.delete(
        i18n.t('common_words.the_permit') + this.permissionForm.name
      ).then((result) => {
        if (result.value) this.deletePermission();
      });
    },

    updateModulesForm() {
      if (this.permissionForm.permission_type == 'General') {
        this.permissionForm.modules = [];
      }
    },

    addEditPermission() {
      this.showHideLoading(true);
      if (this.permissionForm.route == 'permissions') {
        if (this.isUpdate()) {
          this.updateModulesForm();
          Axios.updateMaster(this.permissionForm)
            .then((response) => {
              this.modifyTable(1, this.permissionForm.id, response);
              this.forceRenderMenu();
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.updateModulesForm();
          this.permissionForm.route = 'permissions';
          Axios.saveMaster(this.permissionForm)
            .then((response) => {
              this.modifyTable(0, null, response);
              this.forceRenderMenu();
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deletePermission() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.permissionForm.route = 'permissions';
        Axios.destroyMaster(this.permissionForm)
          .then((response) =>
            this.modifyTable(2, this.permissionForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'permissions/pdf';
      data.name_file = `${i18n.t('common_words.permissions')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'permissions/excel';
      data.name_file = `${i18n.t('common_words.permissions')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('permissions')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });

          Axios.getMasters('businesses/only')
            .then((response1) => {
              this.businesses = this.concatAll(response1.data.data);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('modules/indexfield')
        .then((response) => {
          this.modules = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('permissions');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('permissions');
  },
};
</script>
<style></style>
